import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { checkIfMobile } from "../../services/screen";

const BDialog = React.forwardRef(function BDialog({ open, openToLeft, children, ...rest }, ref) {
  const [offsetX, setOffsetX] = useState(0);
  const paperRef = useRef(null);

  const updateOffset = () => {
    const grid = document.querySelector(".muvika-container-left-grid");
    if (!grid) return;

    const gridRect = grid.getBoundingClientRect();
    const gridCenter = gridRect.left + gridRect.width / 2;
    const offset = window.innerWidth / 2 - gridCenter;

    setOffsetX(offset);
  };

  useEffect(() => {
    if (!open) return;
    const isMobile = checkIfMobile();
    if (isMobile) return;

    updateOffset();
    window.addEventListener("resize", updateOffset);
    window.addEventListener("scroll", updateOffset);

    return () => {
      window.removeEventListener("resize", updateOffset);
      window.removeEventListener("scroll", updateOffset);
    };
  }, [])

  useEffect(() => {
    if (!open) return;
    const isMobile = checkIfMobile();
    if (isMobile) return;

    updateOffset();
    window.addEventListener("resize", updateOffset);
    window.addEventListener("scroll", updateOffset);

    return () => {
      window.removeEventListener("resize", updateOffset);
      window.removeEventListener("scroll", updateOffset);
    };
  }, [open]);

  useEffect(() => {
    if (paperRef.current) {
      updateOffset();
    }
  }, [paperRef.current]);

  const isMobile = checkIfMobile();

  return (
    <Dialog
      ref={ref}
      open={open}
      scroll="paper" // keeps content scrollable
      PaperProps={{
        ref: paperRef,
        sx: isMobile || !openToLeft
          ? { maxHeight: "80vh", overflowY: "auto" }
          : {
            maxHeight: "80vh",
            overflowY: "auto",
            transform: `translateX(-${offsetX}px)`,
          },
      }}
      {...rest}
    >
      {children}
    </Dialog>
  );
});

export default BDialog;
